/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PatientMedicineNotebook,
  PatientMedicineNotebookFromJSON,
  PatientMedicineNotebookFromJSONTyped,
  PatientMedicineNotebookToJSON,
} from "./";

export const PutMedicineNotebookByPatientResponseTypename = "PutMedicineNotebookByPatientResponse" as const;

/**
 *
 * @export
 * @interface PutMedicineNotebookByPatientResponse
 */
export interface PutMedicineNotebookByPatientResponse {
  /**
   *
   * @type {PatientMedicineNotebook}
   * @memberof PutMedicineNotebookByPatientResponse
   */
  medicineNotebook?: PatientMedicineNotebook;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutMedicineNotebookByPatientResponse
   */
  readonly __typename?: string;
}

export function PutMedicineNotebookByPatientResponseFromJSON(json: any): PutMedicineNotebookByPatientResponse {
  return PutMedicineNotebookByPatientResponseFromJSONTyped(json, false);
}

export function PutMedicineNotebookByPatientResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutMedicineNotebookByPatientResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutMedicineNotebookByPatientResponseTypename,

    medicineNotebook: !exists(json, "medicine_notebook")
      ? undefined
      : PatientMedicineNotebookFromJSON(json["medicine_notebook"]),
  };
}

export function PutMedicineNotebookByPatientResponseToJSON(object?: PutMedicineNotebookByPatientResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medicine_notebook: PatientMedicineNotebookToJSON(value.medicineNotebook),
  };
}
